module.exports = __webpack_public_path__ + "img/tamquoc.4ea84021.png";